export const FEATURE_FLAGS = {
  NOTIFICATION_CENTER: 'notificationCenter',
  NEW_ROUTE_MANAGER: 'newRouteManager',
  BILLING_WORK_ORDER_INVOICE_STATUS: 'billingWorkOrderInvoiceStatus',
  INVOICE_BATCHING: 'invoiceBatching',
  PAYMENT_GROUPS: 'paymentGroups',
  GCP_IP: 'gcpIp',
  NOTES_V_2: 'notesV2',
  ACCOUNT_GROUPS: 'accountsGroups',
  SUSPENSIONS: 'suspensions',
  LATE_FEE: 'lateFee',
  RENTAL_FEE: 'rentalFee',
  STATEMENTS: 'statements',
  PAYMENTS_V15: 'payments15',
  ALLOW_NEGATIVE_INVOICE: 'allowNegativeInvoice',
  ACCOUNTING_LOCK: 'accountingLock',
  CS_REDESIGN: 'configuredServiceRedesign',
  WO_REDESIGN: 'woRedesign',
  WO_REDESIGN_V2: 'woRedesignV2',
  LEGACY_CS_DESIGN: 'legacyConfiguredServiceDesign',
  LEGACY_WO_DESIGN: 'legacyWoDesign',
  CS_DRAFT: 'configuredServiceActionPricing',
  CS_DETAILS_AVAILABLE_FEATURES: 'serviceRedesignCoreFeaturesEnabled',
  DISPOSAL_FEES: 'disposalFeesV2',
  DISPOSAL_REVIEW: 'disposalReview',
  CSV_IMPORT_PAYMENTS_BATCH: 'csvImportPaymentsBatch',
  ROUTING_SEQUENCE_CONCURRENCY: 'routingSequenceConcurrency',
  // LD declares it with dashes (routing-sequence-restore); the SDK camelCases it on read.
  ROUTING_SEQUENCE_RESTORE: 'routingSequenceRestore',
  MASTER_SEQUENCE_REVAMP: 'masterSequenceRevamp',
  TAXES_REDESIGN: 'taxesRedesign',
}
